import { css } from '@emotion/react'
import { font } from '~/base'

export const wrapper = css`
  width: 100%;
  position: relative;
`

export const plan = css`
  position: relative;
  width: 100%;
`

/** Liegt ueber den Standflaechen, faengt aber keine Mausereignisse ab. */
export const lineart = css`
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  pointer-events: none;
`

export const areas = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  rect {
    transition: fill-opacity 0.25s ease;
  }

  rect[data-active='true'] {
    cursor: pointer;
  }

  rect[data-active='true']:hover {
    fill-opacity: 0.6;
  }

  rect[data-active='false'] {
    cursor: not-allowed;
  }
`

export const image = css``

export const active = css`
  ${font({ size: 'medium' })}
  position: fixed;
  bottom: 0;
  padding-bottom: calc(var(--gap) / 2);
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  z-index: 999;
  justify-content: center;
  pointer-events: none;
`

export const activeBox = css`
  display: flex;
  margin: 0 auto;
  height: 64px;
  border-radius: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  box-shadow: 0px 6px 10px 0 rgba(0, 0, 0, 0.1);

  border: 2px solid var(--color-path-text);
  color: var(--color-path-text);
  background-color: var(--color-path-base);
`

export const activeTitle = css`
  ${font({ weight: 'bold' })}
  padding-bottom: 4px;
  margin-bottom: 4px;
`

export const activeMain = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const activeName = css`
  filter: brightness(0.9);
`

export const activeBooth = css`
  filter: brightness(0.9);
  ${font({ weight: 'bold', size: 'xsmall' })}
  margin-right: 12px;
  position: relative;
  top: 1px;
`
